/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `draft` - draft
 * * `published` - published
 */
export enum StatusEnum {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}
